import { createAsyncThunk } from '@reduxjs/toolkit';
import userService from '../../../api/services/user';

export const fetchPartnerUsers = createAsyncThunk('partner/fetch-partner-users', async requestData => {
  return await userService.getPartnerUsers(requestData);
});

export const activatePartnerUser = createAsyncThunk('partner/activatePartnerUser', async id => {
  return await userService.activatePartnerUser(id);
});

export const fetchPartnersItems = createAsyncThunk('partner/fetch-partners-items', async requestData => {
  return await userService.getPartnersItems(requestData);
});

export const fetchCategories = createAsyncThunk('partner/fetchCategories', async () => {
  return await userService.fetchCategories();
});

export const fetchMarketplaceCategories = createAsyncThunk('partner/fetchMarketplaceCategories', async () => {
  return await userService.fetchMarketplaceCategories();
});

export const fetchSections = createAsyncThunk('partner/fetchSections', async () => {
  return await userService.fetchSections();
});

export const approveProduct = createAsyncThunk('partner/approveProduct', async requestData => {
  return await userService.approveProduct(requestData);
});

export const getProductById = createAsyncThunk('partner/getProductById', async requestData => {
  return await userService.getProductById(requestData);
});

export const editItem = createAsyncThunk('partner/editItem', async ({ requestData, id }) => {
  let formData = new FormData();

  if (Array.isArray(requestData.photos)) {
    requestData.photos.forEach((image, index) => {
      formData.append(`files`, image);
    });
  }

  if (requestData.photoUrls && requestData.photoUrls?.length) {
    requestData.photoUrls.forEach((image, index) => {
      formData.append(`photoUrls[]`, image.url);
    });
  }
  formData.append('name', requestData.name);
  formData.append('nameAr', requestData.nameAr);
  formData.append('description', requestData.description);
  formData.append('descriptionAr', requestData.descriptionAr);
  formData.append('price', requestData.price);
  formData.append('availableQuantity', requestData.availableQuantity);

  if (requestData.skuNumber) {
    formData.append('skuNumber', requestData.skuNumber);
  }

  if (requestData.sections) {
    formData.append(`sections[]`, requestData.sections);
  }
  if (requestData.categories) {
    formData.append(`categories[]`, requestData.categories);
  }
  if (requestData.webCategories) {
    formData.append(`webCategories[]`, requestData.webCategories);
  }

  return await userService.editItem(formData, id);
});

export const toggleItemAvailability = createAsyncThunk('partner/toggleItemAvailability', async id => {
  return await userService.toggleItemAvailability(id);
});

export const deleteItem = createAsyncThunk('partner/deleteItem', async id => {
  return await userService.deleteItem(id);
});

export const loginToPartnerUser = createAsyncThunk('partner/loginToPartnerUser', async id => {
  return await userService.loginToPartnerUser(id);
});
